  import { jsonInstance } from './Api';

class ApiService {
  // -------------------------
  // Campaign APIs
  // -------------------------

  createCampaignWithScript(data) {
    return jsonInstance.post("/campaign/create-with-script", data);
  }

  startCampaign(campaignId, data) {
    return jsonInstance.put(`/campaign/start/${campaignId}`, data);
  }

  stopCampaign(campaignId, data) {
    return jsonInstance.put(`/campaign/stop/${campaignId}`, data);
  }

  getCampaignSignedUrl(params) {
    return jsonInstance.get("/campaign/signed-url", { params });
  }

  uploadCampaignLead(data) {
    return jsonInstance.post("/campaign/upload-lead", data);
  }

  getCampaignList(params) {
    return jsonInstance.get("/campaign/list", { params });
  }

  getCampaignSampleHeader(params) {
    return jsonInstance.get("/campaign/sample-header", { params });
  }

  getSignedUrl(data) {
    return jsonInstance.post("/campaign/signed-url",data);
  }
    uploadLead(data) {
    return jsonInstance.post("/campaign/upload-lead",data);
  }
   getLeadList(data,params) {
    return jsonInstance.post("/campaign/lead-list",data,{ params });
  }
  getAllCallList(data,params) {
    return jsonInstance.post("/campaign/calls",data,{ params });
  }
 getLeadDetailsById(lead_id) {
    return jsonInstance.get(`/campaign/lead-detail/${lead_id}`);
  }
  getRecordingJobs(data,params) {
    return jsonInstance.get(`/campaign/get-recording-job`,data,{ params });
  }
  createRecordingJob(data) {
    return jsonInstance.post(`/campaign/create-recording-job`,data);
  }
  getRecordingDownloadUrl(job_id) {
    return jsonInstance.get(`/campaign/recording-url/${job_id}`);
  } 

  // -------------------------
  // Options APIs
  // -------------------------

  getCampaignStatusOptions(params) {
    return jsonInstance.get("/option/campaign-status", { params });
  }
   getCampaignOptions(data) {
    return jsonInstance.get("/option/campaigns",data);
  }
   getDispositionOptions(data) {
    return jsonInstance.get("/option/disposition",data);
  }
    getDurationOptions(data) {
    return jsonInstance.post("/option/durations",data);
  }
    getCallStatusOptions(data) {
    return jsonInstance.get("/option/call-status",data);
  }

  getIvrOptions(data) {
    return jsonInstance.post("/option/ivr-options",data);
  }
  getLanguageOptions(data){
    return jsonInstance.get("/option/lang-options",data);
  }
   getDispositionListOptions(data){
    return jsonInstance.get("/option/disposition-list",data);
  }
   getSubDispositionOptions(data){
    return jsonInstance.get("/option/sub-disposition",{ params: data });
  }
  getCampaignPresetOptions(data){
    return jsonInstance.get("/option/campaign-presets",data);
  }
  getPreProcessingOptions(data){
    return jsonInstance.get("/option/pre-processing",data);
  }
   getReportTypeOptions(data){
    return jsonInstance.get("/option/reports",data);
  }
   getScriptOptions(data){
    return jsonInstance.get("/option/scripts", { params: data });
  }
   getUploadDumpTypeOptions(data){
    return jsonInstance.get("/option/upload-dump-types",data);
  }
  
  // Voice Characters APIs
  getVoiceCharacters(params) {
    return jsonInstance.get("/admin/voice-characters", { params });
  }

  createVoiceCharacter(data) {
    return jsonInstance.post("/admin/voice-character", data);
  }

  updateVoiceCharacter(id, data) {
    return jsonInstance.put(`/admin/voice-character/${id}`, data);
  }

  deleteVoiceCharacter(id) {
    return jsonInstance.delete(`/admin/voice-character/${id}`);
  }

  playVoiceCharacter(id) {
    return jsonInstance.get(`/admin/voice-character/${id}/play`);
  }
  
  getVoiceCharacterOptions(params) {
    return jsonInstance.get("/option/voice-characters", { params });
  }
  
   getBatchesOptions(id){
    return jsonInstance.get(`/campaign/available-batches/${id}`);
  }
  getRecordingSignedUrl(callId) {
  return jsonInstance.get(`/campaign/calls-record/${callId}`);
}
 getCallbackLeadCount(data) {
    return jsonInstance.post(`/campaign/rechurn-count`,data);
  } 
  updateLeadCallback(data) {
    return jsonInstance.post(`/campaign/rechurn`,data);
  } 
   updateCallEndDisposition(data) {
    return jsonInstance.post(`/update-call-end-disposition`,data);
  } 
  getReports(data) {
    return jsonInstance.post(`/report`,data);
  }
  
  
  testTts(data) {  
    return jsonInstance.post('/voice-test/tts', data, {
      responseType: 'blob'
    });
  }
  
  
  getTtsVoices(ttsType, gender) {
    return jsonInstance.get(`/voice-test/voices/${ttsType}`, {
      params: { gender: gender || 'female' }
    });
  }
  getDefaultVoiceSetting(ttsType) {
    return jsonInstance.get(`/option/default-voice-settings/${ttsType}`);
  }
  getCompanyOptions() {
    return jsonInstance.get("/option/companys");
  }

  getKeywordsType() {
    return jsonInstance.get("/keywords/types");
  }

  getKeywords(payload) {
    const { pagination, ...rest } = payload || {};
    return jsonInstance.get("/keywords", {
      params: {
        page: pagination?.page || 1,
        size: pagination?.size || 20,
        ...rest,
      },
    });
  }

  searchKeyword(term, filters, company) {
    return jsonInstance.get(`/keywords/search`, { params: { term, company } });
  }

  addKeyword(data) {
    return jsonInstance.post("/keywords", data);
  }

  deleteCalls(data) {
    return jsonInstance.delete("/campaign/calls", { data });
  }
  
  getProcessTypes() {
    return jsonInstance.get("/audit-template/process-types");
  }

  getPresetTemplates() {
    return jsonInstance.get("/audit-template/preset-templates");
  }

  getTemplates(params) {
    return jsonInstance.get("/audit-template/templates", { params });
  }

  assignCampaignTemplate(campaignId, data) {
    return jsonInstance.put(`/campaign/${campaignId}/template`, data);
  }

  async getSubprocesses(params) {
    const res = await this.getTemplates(params);
    const list = Array.isArray(res.data)
      ? res.data
      : (res.data?.data || res.data?.subprocesses || []);
    return { ...res, data: list };
  }

  getTemplateById(id) {
    return jsonInstance.get(`/audit-template/${id}`);
  }

  addTemplate(data) {
    return jsonInstance.post("/audit-template", data);
  }

  updateTemplate(id, data) {
    return jsonInstance.put(`/audit-template/${id}`, data);
  }

  deleteTemplate(id) {
    return jsonInstance.delete(`/audit-template/${id}`);
  }

  duplicateTemplate(id, newName) {
    const payload = newName ? { name: newName } : {};
    return jsonInstance.post(`/audit-template/duplicate/${id}`, payload, {
      params: newName ? { new_name: newName } : {}
    });
  }


  getDefaultReportHeaders() {
    return jsonInstance.get("/option/default-report-headers");
  }

  getReportFormat(templateId) {
    return jsonInstance.get(`/audit-template/report-format/${templateId}`);
  }

  updateReportFormat(templateId, data) {
    return jsonInstance.post(`/audit-template/update-report-format/${templateId}`, data);
  }

  getAuditReport(payload, params) {
    return jsonInstance.post("/report/audit-report", payload, { params });
  }

  getTranscriptionDetailById(id) {
    return jsonInstance.get(`/report/audit-call/${id}`);
  }

  getCallById(callId) {
    return jsonInstance.get(`/calls/${callId}`);
  }

  syncCallToCqa(callId, data = {}) {
    return jsonInstance.post(`/calls/sync-call/${callId}`, data);
  }

  updateQualityDetails(id, data) {
    return jsonInstance.post(`/report/update-quality-details/${id}`, data);
  }
}

export default new ApiService();
